
import { useApiBase } from '../../base/api-base';
import { useCallback } from "react";
import { VariaveisAmbiente } from "config";
import { ApiListModel } from "model/api/gestao/api-list-model/api-list-model";
import { DestinatariosModel } from 'model/api/gestao/destinatarios/destinatarios-model';

export function useGetRespostasDestinatarios() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<DestinatariosModel>>();

    const getRespostasDestinatarios = useCallback(
        async (page: number, propagandaId: string, queryBusca?: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || (queryBusca && queryBusca?.length > 0) ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `/v1/Propaganda/${propagandaId}/Destinatarios${queryFinal}`,
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                method: 'GET',
                enviarTokenUsuario: true
            })
        },
        [invocarApi]);
    return {
        ...outrasPropriedades,
        getRespostasDestinatarios,
    }
}